import { render, staticRenderFns } from "./ExpressAddress.vue?vue&type=template&id=2271bb5e&scoped=true&"
import script from "./ExpressAddress.vue?vue&type=script&lang=js&"
export * from "./ExpressAddress.vue?vue&type=script&lang=js&"
import style0 from "./ExpressAddress.vue?vue&type=style&index=0&id=2271bb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271bb5e",
  null
  
)

export default component.exports